// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ReactNative-button-SEIsN {\n  cursor: pointer;\n}\n.ReactNative-button-clicked-1JsQH {\n  opacity: 0.5;\n}\n", "",{"version":3,"sources":["webpack://./src/libs/exaforte/react/ReactNative.less"],"names":[],"mappings":"AACA;EACI,eAAA;AAAJ;AAGA;EACI,YAAA;AADJ","sourcesContent":["@environment_type_id: 1;\n.button {\n    cursor: pointer;\n}\n\n.button-clicked {\n    opacity: 0.5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "ReactNative-button-SEIsN",
	"button-clicked": "ReactNative-button-clicked-1JsQH"
};
export default ___CSS_LOADER_EXPORT___;
